module.exports = __webpack_public_path__ + "img/dongji_ps_09.7b0ec8e2.jpg";